import { createAction } from 'redux-act';
import { INewEcoAgreement,IUpdateEcoAgreement,IRespondEcoAgreement,IRespondEcoAgreementUpdate,
    IEndEcoAgreement,INewEcoPurchase,IUpdateEcoPurchase, INewEcoTransfer,
    IUpdateEcoTransfer, IEcoSetting  } from '@app-types/websocket/economy.types';

export const newAgreement = createAction<INewEcoAgreement>('new agreement');
export const updateAgreement = createAction<IUpdateEcoAgreement>('update agreement');
export const respondAgreement = createAction<IRespondEcoAgreement>('respond agreement');
export const respondAgreementUpdate = createAction<IRespondEcoAgreementUpdate>('respond agreement update');
export const endAgreement = createAction<IEndEcoAgreement>('end agreement');
export const seenAgreement = createAction<number>('Seen agreement');
export const archiveAgreement = createAction<number>('archive agreement');
export const archiveAgreementUpdate = createAction<number>('archive agreement update');

export const newPurchase = createAction<INewEcoPurchase>('new purchase');
export const updatePurchase = createAction<IUpdateEcoPurchase>('update purchase');
export const disputePurchase = createAction<number>('dispute purchase');
export const deletePurchase = createAction<number>('delete purchase');
export const restorePurchase = createAction<number>('restore purchase');
export const seenPurchase = createAction<number>('Seen purchase');
export const archivePurchase = createAction<number>('Archive purchase');

export const newTransfer = createAction<INewEcoTransfer>('new transfer');
export const updateTransfer = createAction<IUpdateEcoTransfer>('update transfer');
export const deleteTransfer = createAction<number>('delete transfer');
export const restoreTransfer = createAction<number>('restore transfer');
export const disputeTransfer = createAction<number>('dispute transfer');
export const seenTransfer = createAction<number>('seen transfer');
export const archiveTransfer = createAction<number>('archive transfer');

export const updateEcoSettings = createAction<IEcoSetting[]>('update eco settings');


// WEBPACK FOOTER //
// ./src/services/economy/economy.actions.ts